const timestampToDate = function (timestamp, type = 0) {
  const date = new Date(timestamp)
  const year = date.getFullYear() // 获取年份
  let month = date.getMonth() + 1 // 获取月份（注意月份从0开始，需要加1）
  if (month < 10) {
    month = '0' + month
  }
  let day = date.getDate() // 获取日期
  if (day < 10) {
    day = '0' + day
  }
  let hour = date.getHours() // 获取小时
  if (hour < 10) {
    hour = '0' + hour
  }
  let minute = date.getMinutes() // 获取分钟
  if (minute < 10) {
    minute = '0' + minute
  }
  let second = date.getSeconds() // 获取秒数
  if (second < 10) {
    second = '0' + second
  }
  let returnResult = year + '-' + month + '-' + day
  if (type === 1) {
    returnResult = returnResult + ' ' + hour + ':' + minute + ':' + second
  }
  return returnResult
}

export { timestampToDate }
